import coreMessages from './messages/core-messages'
import emptyMessages from './messages/empty-messages'
import stateMessages from './messages/state-messages'
import deliveryModeMessages from './messages/delivery-mode-messages'
import orderMessages from './messages/order-messages'
import paymentMessages from './messages/payment-messages'
import cartMessages from './messages/cart-messages'
import stockOperationMessages from './messages/stock-operation-messages'
import merge from 'deepmerge'

const messages = merge.all([
    coreMessages,
    emptyMessages,
    stateMessages,
    deliveryModeMessages,
    orderMessages,
    paymentMessages,
    cartMessages,
    stockOperationMessages
])

export default messages
